import React, { useState, useEffect } from 'react';
import Dashboard from './Dashboard/index';
import DashboardConnect from './DashboardConnect';
import { analyticsService } from '@/services/analytics';
import { apiService } from '@/services/api';

interface Property {
  id: number;
  property_id: string;
  property_name: string;
  website_url: string;
  industry_vertical: string | null;
  timezone: string;
  is_selected: boolean;
  account: number;
  account_name: string;
  account_id: string;
  organization: number;
  organization_name: string;
  project: number;
  project_name: string;
  created_at: string;
  updated_at: string;
}

const DashboardWrapper: React.FC = () => {
  const [activeConnection, setActiveConnection] = useState<any>(null);
  const [activeProperty, setActiveProperty] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkConnectionAndProperty = async () => {
      try {
        // Check for active connection
        const connection = await analyticsService.getActiveConnection();
        setActiveConnection(connection);
        console.log("connection", connection)
        // If there's a connection, get the list of properties and find the active one
        if (connection) {
          try {
            const propertiesResponse = await apiService.get('/analytics/properties/', {
              params: { period: '7d' } // Default period for properties list
            });
            
            const properties = (propertiesResponse.data?.properties || []) as Property[];
            console.log('Available properties:', propertiesResponse);
            
            // Find the active property
            const activeProperty = properties.find((prop: Property) => prop.is_selected);
            // console.log('Found active property:', activeProperty);
            if (activeProperty) {
              console.log('Found active property:', activeProperty);
              setActiveProperty({
                id: activeProperty.property_id,
                name: activeProperty.property_name,
                website_url: activeProperty.website_url,
                account_name: activeProperty.account_name,
                organization_name: activeProperty.organization_name,
                project_name: activeProperty.project_name,
                timezone: activeProperty.timezone
              });
            } else {
              console.log('No active property found');
            }
          } catch (error) {
            console.error('Error fetching properties:', error);
          }
        }
      } catch (error) {
        console.error('Error checking connection and property:', error);
      } finally {
        setLoading(false);
      }
    };

    checkConnectionAndProperty();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Show Dashboard only if both connection AND active property exist
  if (activeConnection && activeProperty) {
    return <Dashboard activeProperty={activeProperty} />;
  }

  // If no active connection or no active property, show the connection prompt
  return <DashboardConnect />;
};

export default DashboardWrapper;
